// extracted by mini-css-extract-plugin
module.exports = {"imageText":"Image_imageText__hHyCz"};